import { render, staticRenderFns } from "./ReadOnlyEditorView.vue?vue&type=template&id=1fe0b660"
import script from "./ReadOnlyEditorView.vue?vue&type=script&lang=js"
export * from "./ReadOnlyEditorView.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyEditorView.vue?vue&type=style&index=0&id=1fe0b660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports